import React, { Component } from 'react';
import Button from '../../atoms/Button';
import ButtonGroup from '../../atoms/ButtonGroup';
import Dropdown from '../../atoms/Dropdown';
import IconButton from '../../atoms/IconButton';
import { filterConditionState, filterKeyState } from '../../../redux/reducers/CurrentFilterReducer';
import { SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';
import { LoadingStatus } from '../../../redux/reducers/LoadingStatusReducer';
import { UserState } from '../../../redux/reducers/UserReducer';
import { MESSAGETYPE, SCREEN } from '../../../Common';

interface FilterSelectorHandler {
  // 現在のフィルタ
  currentFilter: filterKeyState;
  // フィルタ一覧
  filterList: filterConditionState[];
  // 現在の検索条件
  searchCondition: SearchConditionState;
  // ログインユーザ
  loginUser: UserState;
  // ローディング状態
  loadingStatus: LoadingStatus;

  clearFilter: () => void;
  updateCurrentFilter: (filterCondition: filterConditionState) => void;
  fetchCustomFilter: (filterList: filterConditionState[], userId: string) => void;
}

interface FilterSelectorProps extends FilterSelectorHandler {
  updateNotice: (screenId: string, messageType: string, messageText: string) => void;
}

interface FilterSelectorState {
  anchorEl: HTMLElement | null;
  isActive: boolean;
  selectedFilter: filterConditionState;
}

class FilterSelector extends Component<FilterSelectorProps, FilterSelectorState> {
  constructor(props: FilterSelectorProps) {
    super(props);
    let isActive = false;
    let selectedFilter: filterConditionState = {
      filterKey: '',
      filterTitle: '',
      searchConditions: [],
    };
    if (this.props.currentFilter.filterKey) {
      for (let i = 0; i < this.props.filterList.length; i++) {
        if (this.props.filterList[i].filterKey === this.props.currentFilter.filterKey) {
          isActive = true;
          selectedFilter = { ...this.props.filterList[i] };
          break;
        }
      }
    }
    console.log(selectedFilter);
    this.state = {
      anchorEl: null,
      isActive: isActive,
      selectedFilter: selectedFilter,
    };

    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.toggleFilterActive = this.toggleFilterActive.bind(this);
  }

  componentDidMount() {
    if (this.props.loadingStatus.isInitial) {
      this.props.fetchCustomFilter(this.props.filterList, this.props.loginUser.crewCd);
    }
  }

  onChangeFilter(filterConditions: filterConditionState) {
    this.setState({
      selectedFilter: { ...filterConditions },
    });
    if (this.state.isActive) {
      this.props.updateCurrentFilter(filterConditions);
    }
  }

  toggleFilterActive() {
    const before = this.state.isActive;
    if (before) {
      this.props.clearFilter();
    } else {
      this.props.updateCurrentFilter(this.state.selectedFilter);
    }
    this.setState({
      isActive: !before,
    });
    this.props.updateNotice(SCREEN.UNDER_NEGOTIATION.ID, MESSAGETYPE.NORMAL, '');
  }

  // フィルタドロップダウンの中身
  renderPopover() {
    return (
      <div data-testid-e2e='filterSelector-openDropDown'>
        <ul className='uc-radio-group u-min-ws u-ph8'>
          {this.props.filterList.map((filter: filterConditionState) => {
            return (
              <li key={filter.filterKey} className='u-w-full'>
                <div className='uc-radio'>
                  <input
                    onChange={() => this.onChangeFilter(filter)}
                    type='radio'
                    name='demo-radio'
                    value={filter.filterKey}
                    id={filter.filterKey}
                    checked={filter.filterKey === this.state.selectedFilter.filterKey}
                    data-testid-e2e={`filterSelector-radio-${filter.filterKey}`}
                  />
                  <label
                    htmlFor={filter.filterKey}
                    className='uc-radio__label'
                    data-testid-e2e={`filterSelector-label-${filter.filterKey}`}>
                    {filter.filterTitle}
                  </label>
                </div>
                <IconButton icon='settings' className='u-float-right'></IconButton>
              </li>
            );
          })}
        </ul>
        <div className='uc-divider' aria-disabled />
        <div className='u-ph8'>
          <Button leftIcon='add' label='新規フィルタ' type='transparent' disabled></Button>
        </div>
      </div>
    );
  }

  render() {
    const { anchorEl } = this.state;

    return (
      <ButtonGroup className='u-mr8'>
        <ButtonGroup.Button
          className='filter-selector'
          onClick={() => this.toggleFilterActive()}
          isActive={this.state.isActive}
          label={
            <>
              <span className={this.state.isActive ? 'u-text-white' : 'u-text-dark'}>フィルタ: </span>
              {this.state.selectedFilter.filterTitle || 'なし'}
            </>
          }
          leftIcon='filter_alt'
          data-testid-e2e='filterSelector-toggle'
        />
        {/**
         * MEMO strict Modeで Warning「findDOMNode is deprecated in StrictMode.」が発生する
         * https://ja.reactjs.org/docs/strict-mode.html
         */}
        <Dropdown
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          popover={this.renderPopover()}
          onClose={() => this.setState({ anchorEl: null })}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}>
          <ButtonGroup.Button
            aria-describedby='hoge-button'
            onClick={(e: React.MouseEvent<HTMLElement>) => this.setState({ anchorEl: e.currentTarget })}
            leftIcon='arrow_drop_down'
            className='u-flex-none u-w5s'
            data-testid-e2e='filterSelector-dropDown'
          />
        </Dropdown>
      </ButtonGroup>
    );
  }
}

export default FilterSelector;
